import React, { useState } from "react";
import { Tabs, Tab, Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BankDetailModal from "../Modal/BankDetailModal";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import rafiki from "../assets/images/rafiki.png";
import vector from "../assets/images/Vector 388.png";
import { useLocation } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// Dynamic DataTable Component
const DynamicDataTable = ({ headers, data, onEdit, onDelete }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        {/* Table Header */}
        <thead>
          <tr className="bg-secondary-700">
            {headers.map((header, index) => (
              <th
                key={index}
                className="p-3 bg-secondary-700 text-center text-white"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map(
                  (header, colIndex) =>
                    header !== "PCode" && ( // Hide PCode column
                      <td key={colIndex} className="p-3 border border-gray-500">
                        {header === "Action" ? (
                          <div className="flex space-x-2">
                            <IconButton
                              color="primary"
                              onClick={() => onEdit(row, rowIndex)}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => onDelete(rowIndex)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        ) : (
                          row[header] || "-"
                        )}
                      </td>
                    )
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length} className="p-3 text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const BankFileLand = () => {
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.auth);
  debugger;
  const searchParams = new URLSearchParams(location.search);
  const deed = searchParams.get("deed") || "N/A";
  const subdeed = searchParams.get("subdeed") || "N/A";
  const [tabIndex, setTabIndex] = useState(0);
  const [feeData, setFeeData] = useState({
    Loan: "",
    Stamp: "",
    Pages: "",
    Words: "",
  });
  const relationData = [
    { value: "S/O", label: "S/O" },
    { value: "W/O", label: "W/O" },
    { value: "D/O", label: "D/O" },
    { value: "C/O", label: "C/O" },
    { value: "MALE", label: "MALE" },
    { value: "FEMALE", label: "FEMALE" },
  ];

  const occupationData = [
    { value: "सर्विस", label: "सर्विस" },
    { value: "ग्रहणी", label: "ग्रहणी" },
    { value: "खेती", label: "खेती" },
    { value: "मज़दूरी", label: "मज़दूरी" },
    { value: "कातिब", label: "कातिब" },
    { value: "वकील", label: "वकील" },
    { value: "स्टा. विक्रेटा", label: "स्टा. विक्रेटा" },
    { value: "अन्य", label: "अन्य" },
  ];

  const unitData = [
    { value: "SM", label: "SM" },
    { value: "HECTARES", label: "HECTARES" },
  ];

  const [tabData, setTabData] = useState([
    {
      id: 0,
      label: "PROPERTY DETAILS",
      headers: [
        "Location",
        "Khatoni",
        "Khewat",
        "Khasra",
        "HouseNo",
        "Area",
        "Unit",
        "Action",
      ],
      data: [],
      fields: [
        { name: "Location", type: "text" },
        { name: "Khatoni", type: "text" },
        { name: "Khewat", type: "text" },
        { name: "Khasra", type: "text" },
        { name: "HouseNo", type: "text" },
        { name: "Area", type: "text" },
        { name: "Unit", type: "select", options: unitData },
      ],
    },
    {
      id: 1,
      label: "FIRST PARTY DETAILS",
      headers: [
        "pcode",
        "Name",
        "Relation",
        "Relative Name",
        "Address",
        "Other",
        "Occupation",
        "Form60/PAN No.",
        "Action",
      ],
      data: [],
      fields: [
        { name: "Name", type: "text" },
        { name: "Relation", type: "select", options: relationData },
        { name: "Relative Name", type: "text" },
        { name: "Address", type: "text" },
        { name: "Other", type: "text" },
        { name: "Occupation", type: "select", options: occupationData },
        { name: "Form60/PAN No.", type: "text" },
      ],
    },
    {
      id: 2,
      label: "SECOND PARTY DETAILS",
      headers: [
        "pcode",
        "Name",
        "Relation",
        "Relative Name",
        "Address",
        "Other",
        "Occupation",
        "Form60/PAN No.",
        "Action",
      ],
      data: [],
      fields: [
        { name: "Name", type: "text" },
        { name: "Relation", type: "select", options: relationData },
        { name: "Relative Name", type: "text" },
        { name: "Address", type: "text" },
        { name: "Other", type: "text" },
        { name: "Occupation", type: "select", options: occupationData },
        { name: "Form60/PAN No.", type: "text" },
      ],
    },
    {
      id: 3,
      label: "FEE DETAILS",

      data: [],
    },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const [newRowData, setNewRowData] = useState({});
  const [fields, setFields] = useState([]);
  const [editRowIndex, setEditRowIndex] = useState(null);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleFeeChange = (e) => {
    setFeeData({ ...feeData, [e.target.id]: e.target.value });
  };

  const handleAddNew = () => {
    setFields(tabData[tabIndex].fields);
    setNewRowData(
      tabData[tabIndex].fields.reduce((acc, field) => {
        acc[field.name] = "";
        return acc;
      }, {})
    );
    setEditRowIndex(null); // Reset edit index
    setOpenModal(true);
  };

  const handleEdit = (row, rowIndex) => {
    setFields(tabData[tabIndex].fields);
    setNewRowData(row); // Prefill modal with selected row data
    setEditRowIndex(rowIndex); // Track row index for updating
    setOpenModal(true);
  };

  const handleDelete = (rowIndex) => {
    const updatedTabData = [...tabData];
    updatedTabData[tabIndex].data.splice(rowIndex, 1);
    setTabData(updatedTabData);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSave = () => {
    const updatedTabData = [...tabData];
    const currentTab = updatedTabData[tabIndex];

    // Find missing fields (excluding "Other")
    const missingFields = fields
      .filter((field) => field.name !== "Other") // Exclude "Other"
      .filter((field) => !newRowData[field.name]?.trim()) // Check for empty values
      .map((field) => field.name); // Get names of missing fields

    if (missingFields.length > 0) {
      toast.info(
        `Missing required fields in ${
          tabData[tabIndex].label
        }: ${missingFields.join(", ")}`
      );

      return;
    }

    if (tabIndex === 0) {
      // PROPERTY DETAILS - Assign loc_id as prefix (rowIndex + 1)
      const newLocId = currentTab.data.length + 1;
      newRowData.loc_id = newLocId; // Ensure loc_id is an integer
    } else if (tabIndex === 1 || tabIndex === 2) {
      // FIRST & SECOND PARTY DETAILS - Assign pcode
      let prefix = tabIndex === 1 ? "01" : "02";
      const lastEntry = currentTab.data[currentTab.data.length - 1];
      const lastPCode = lastEntry ? parseInt(lastEntry.pcode.slice(2)) : 0;
      const newPCode = `${prefix}${String(lastPCode + 1).padStart(2, "0")}`;
      newRowData.pcode = newPCode;
    }

    if (editRowIndex !== null) {
      currentTab.data[editRowIndex] = newRowData;
    } else {
      currentTab.data.push(newRowData);
    }

    setTabData(updatedTabData);
    setOpenModal(false);
    setNewRowData({});
    setEditRowIndex(null);
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setNewRowData((prevData) => ({
      ...prevData,
      // [name]: value,
      [name]: name === "Area" ? value.replace(/\D/g, "") : value,
    }));
  };

  const handleFinalSave = async (e) => {
    e.preventDefault();
    debugger;

    if (!deed || deed === "N/A") {
      toast.error("Error: Deed is required.");
      return;
    }
    if (!subdeed || subdeed === "N/A") {
      toast.error("Error: Sub-Deed is required.");
      return;
    }
    let isValid = true;

    // Read Fee Details values directly from input fields
    let loanAmount = feeData.Loan;
    let stampDuty = feeData.Stamp || "";
    let totalPages = feeData.Pages || "";
    let totalWords = feeData.Words || "";

    if (!loanAmount || !stampDuty || !totalPages || !totalWords) {
      toast.error("Error: All Fee Details fields must be filled.");
      return;
    }

    let firstPartyEntries = [];
    let secondPartyEntries = [];
    let propertyEntries = [];

    // Ensure all required tabs have at least one entry
    tabData.forEach((tab) => {
      if (tab.label === "FIRST PARTY DETAILS") {
        if (!tab.data.length) {
          toast.error(
            "Error: First Party Details must have at least one entry."
          );
          isValid = false;
          return;
        }
        tab.data.forEach((entry) => {
          firstPartyEntries.push(
            `1~${entry.pcode}~${entry.Name}~${entry["Relative Name"]}~${entry.Other}~${entry.Address}~${entry["Occupation"]}~NULL~${entry.Relation}~${entry["Form60/PAN No."]}`
          );
        });
      } else if (tab.label === "SECOND PARTY DETAILS") {
        if (!tab.data.length) {
          toast.error(
            "Error: Second Party Details must have at least one entry."
          );
          isValid = false;
          return;
        }
        tab.data.forEach((entry) => {
          secondPartyEntries.push(
            // `${entry.pcode}~${entry.Name}~${entry.Relation}~${entry["Relative Name"]}~${entry.Address}~${entry.Other}~${entry["Occupation"]}~${entry["Form60/PAN No."]}`
            `1~${entry.pcode}~${entry.Name}~${entry["Relative Name"]}~${entry.Other}~${entry.Address}~${entry["Occupation"]}~NULL~${entry.Relation}~${entry["Form60/PAN No."]}`
          );
        });
      } else if (tab.label === "PROPERTY DETAILS") {
        if (!tab.data.length) {
          toast.error("Error: Property Details must have at least one entry.");
          isValid = false;
          return;
        }
        tab.data.forEach((entry) => {
          propertyEntries.push(
            `${entry.loc_id}~${entry.Location}~${entry.Khatoni}~${entry.Khewat}~${entry.Khasra}~${entry["HouseNo"]}~${entry.Area}~${entry.Unit}`
          );
        });
      }
    });

    if (!isValid) return;

    const firstPartyName = firstPartyEntries[0]
      ? firstPartyEntries[0].split("~")[2]
      : "";
    const secondPartyName = secondPartyEntries[0]
      ? secondPartyEntries[0].split("~")[2]
      : "";

    // Combine First and Second Party details into `party_data` (separated by #)
    let party_data =
      [...firstPartyEntries, ...secondPartyEntries].join("#") + "#";

    // Combine Property details into `property_data` (separated by #)
    let property_data = propertyEntries.join("#") + "#";

    // Construct final payload based on the API model
    const finalPayload = {
      dCode: "04", // Assuming this is a state variable holding the DCode
      sroCode: "02", // Assuming this is a state variable holding the SROCode
      deedCode: deed, // Ensure this is correctly assigned
      subDeedCode: subdeed, // Ensure this is correctly assigned
      loanAmount: parseInt(loanAmount),
      stampDuty: parseInt(stampDuty),
      pages: parseInt(totalPages),
      words: parseInt(totalWords),
      partyData: party_data,
      propertyData: property_data,
      userName: userDetails?.email,
      appName: firstPartyName,
      authPerson: secondPartyName,
    };

    debugger;
    console.log("Final Payload:", finalPayload);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Bank/generate-bank-file`,
        finalPayload
      );
      debugger;
      console.log("responseeeeee", response);
      if (response) {
        console.log("API Response:", response.data);
        toast.success(
          `Data successfully submitted! Registration Number: ${response.data.registrationNumber}`
        );
        setFeeData({
          Loan: "",
          Stamp: "",
          Pages: "",
          Words: "",
        });

        // Reset Tab Data (clear all rows)
        setTabData((prevTabs) =>
          prevTabs.map((tab) => ({
            ...tab,
            data: [], // Clear the data array for each tab
          }))
        );
      } else {
        toast.error("Error: Failed to submit data.");
      }
    } catch (error) {
      debugger;
      console.error("API Error:", error);
      toast.error("An error occurred while submitting the data.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>
        <div className="p-6 bg-white flex flex-col">
          <h2 className="text-xl font-semibold">Bank File Land</h2>
          <div className="justify-between grid grid-cols-1 lg:grid-cols-3 gap-4  m-4">
            <div className="grid-col-1">
              <p>
                <strong>Deed:</strong> {deed || "N/A"}
              </p>
              <p>
                <strong>Sub-Deed:</strong> {subdeed || "N/A"}
              </p>
            </div>
            <div>
              <p>
                <strong>Book No:</strong> 1
              </p>
              <p>
                <strong>Year:</strong> 2024
              </p>
            </div>
          </div>

          {/* Tabs */}
          <div className="mx-4 my-2 font-['Trebuchet_MS']">
            <div className="flex border-b-0">
              {tabData.map((tab, index) => (
                <button
                  key={tab.id}
                  onClick={() => setTabIndex(index)}
                  className={`px-6 py-3 font-bold rounded-t-lg ${
                    tabIndex === index
                      ? "bg-secondary-100 border border-primary-100 border-b-0 opacity-100"
                      : "opacity-70"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {tabIndex === 3 ? (
              <div className="p-5 border border-primary-100 bg-secondary-100 border-t-0 border-b-0 flex justify-center relative">
                <div className="grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 items-center justify-between mt-16 relative gap-8">
                  {/* <div className="col-span-1"></div> */}
                  <div className="col-span-1 flex justify-center relative">
                    <img
                      src={rafiki}
                      alt="Fee Details"
                      className="rounded-lg"
                    />
                  </div>

                  <svg
                    className="absolute pointer-events-none hidden xl:block w-full max-w-[500px] lg:max-w-[600px] xl:max-w-[700px] 
             xl:left-[22%] 2xl:left-[17%] top-0"
                    viewBox="0 0 700 200"
                  >
                    <defs>
                      <filter id="glow">
                        <feGaussianBlur
                          stdDeviation="2.5"
                          result="coloredBlur"
                        />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                    </defs>

                    <path
                      id="path"
                      d="M 50 180 H 300 V 50 H 650"
                      stroke="blue"
                      strokeWidth="2"
                      fill="transparent"
                      strokeDasharray="6,4"
                      strokeLinecap="round"
                      filter="url(#glow)"
                    >
                      <animate
                        attributeName="stroke-dashoffset"
                        from="20"
                        to="0"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    </path>

                    <polygon points="-10,-5 10,0 -10,5" fill="orange">
                      <animateMotion
                        repeatCount="indefinite"
                        dur="4s"
                        rotate="auto"
                      >
                        <mpath href="#path" />
                      </animateMotion>
                    </polygon>
                  </svg>

                  <div className="col-span-1 hidden xl:block"> </div>
                  <div className="col-span-1 border-2 border-primary-300 rounded-lg bg-primary-50 p-6 w-full relative">
                    <h3 className="text-lg font-semibold mb-4">
                      Fee Details Form
                    </h3>
                    <form>
                      {[
                        { id: "Loan", label: "Loan Amount" },
                        { id: "Stamp", label: "Stamp Duty" },
                        { id: "Pages", label: "Total Pages" },
                        { id: "Words", label: "Total Words" },
                      ].map((field) => (
                        <div key={field.id} className="col-1 mb-4">
                          <div className="relative">
                            <input
                              id={field.id}
                              type="text"
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              value={feeData[field.id]}
                              onChange={handleFeeChange}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /\D/g,
                                  ""
                                ); // Remove non-numeric characters
                                handleFeeChange({
                                  target: {
                                    name: field.name,
                                    value: e.target.value,
                                  }, // Update state properly
                                });
                              }}
                            />
                            <label
                              htmlFor={field.id}
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              {field.label}
                            </label>
                          </div>
                        </div>
                      ))}
                      {/* Save Button Adjusted Position */}
                      <div className="flex justify-end mt-6">
                        <button
                          onClick={handleFinalSave}
                          className="bg-primary-600 text-white px-6 py-2 rounded shadow-lg hover:bg-primary-700 transition-all"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="p-5 border border-primary-100 bg-secondary-100 border-t-0 border-b-0 flex justify-end">
                  <button
                    onClick={handleAddNew}
                    className="bg-primary-600 text-white px-4 py-2 rounded"
                  >
                    Add New
                  </button>
                </div>

                <div className="p-5 border border-primary-100 bg-secondary-100 rounded-b-lg border-t-0">
                  {tabData.length > 0 && (
                    <DynamicDataTable
                      headers={tabData[tabIndex].headers}
                      data={tabData[tabIndex].data}
                      onEdit={handleEdit}
                      onDelete={handleDelete}
                    />
                  )}
                </div>
              </>
            )}
          </div>

          {/* BankDetailModal */}
          <BankDetailModal
            open={openModal}
            onClose={handleCloseModal}
            handleSave={handleSave}
            fields={fields}
            newRowData={newRowData}
            handleFieldChange={handleFieldChange}
            tabLabel={tabData[tabIndex].label}
          />
        </div>
      </div>
    </div>
  );
};

export default BankFileLand;
